import React from 'react';
import { Col, Form, Input, InputNumber, Row } from 'antd';

import './ColloForm.scss';
import OptionalLabel from '../../Elements/OptionalLabel';

const ColloForm = ({ name, isNew }) => {
  return (
    <div className={`ColloForm`}>
      <Form.Item name={isNew ? [name, 'orderId'] : 'orderId'} style={{ display: 'none' }}></Form.Item>
      <Row gutter={24}>
        <Col span={3}>
          <Form.Item name={isNew ? [name, 'length'] : 'length'} label="Size (LxWxH)">
            <InputNumber min={0} type="number" size="large" suffix="mm" />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item name={isNew ? [name, 'width'] : 'width'} label={<></>}>
            <InputNumber min={0} type="number" size="large" suffix="mm" />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item name={isNew ? [name, 'height'] : 'height'} label={<OptionalLabel title=" " />}>
            <InputNumber min={0} type="number" size="large" suffix="mm" />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item name={isNew ? [name, 'weight'] : 'weight'} label={<OptionalLabel title="Weight" />}>
            <InputNumber min={0} type="number" size="large" suffix="g" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name={isNew ? [name, 'barcode'] : 'barcode'} label={<OptionalLabel title="Barcode" />}>
            <Input size="large" />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default ColloForm;
